
<template>
  <div class="news-background section">
    <div class="content-wrapper">
      <div class="content-bg">
        <span v-if="isMobile" class="title-text">{{data.titleCh}}</span>
        <div class="content">
          <div class="content-list" v-for="item in data.content.list" :key="item.id">

            <div class="list-wrapper">
              <img class="logo" :src="isMobile ? item.idLogoMobile : item.idLogo" alt="">
              <a :href="item.link" class="text" target="_blank">{{item.text}}</a>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import VueTypes from 'vue-types'

export default {
  components: {
  },
  props: {
    data: VueTypes.object.def({})
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['isMobile'])
  }
}
</script>

<style lang="scss" scoped>

.news-background {
  padding-top: 60px;
  background: #F7F8FA;

  @include mobile {
    padding-top: 25px;
  }
}

.content-wrapper {
  display: flex; justify-content: center; align-items: center;
}

.content-bg {
  width: 1200px;
  background: url('~@/assets/transSave/resource/image/8a/95/8a426bbebf30d45f8fab33b52e62e795.png') top center / cover no-repeat;

  @include mobile {
    width: 100%; height: 100%;
    padding: 25px 22px 0 18px;
    background: url('~@/assets/transSave/resource/image/e7/ed/e783df0cfc8588abb69afe80f44161ed.png') center / cover no-repeat;
  }
}

.title-text {
  margin: 24px 0 0 20px;
  font-size: 18px; font-family: Alibaba-PuHuiTi-Heavy;
  color: #FFFFFF;
  line-height: 25px;
  letter-spacing: 2px;

  @include mobile {
    margin: 23px 0 0 20px;
  }
}

.content {
  display: flex; flex-wrap: wrap; column-gap: 60px;
  width: 1120px;
  margin: 140px 40px 40px;
  padding: 18px 60px 40px;
  background: #FFFFFF;

  @include mobile {
    width: 100%; height: 100%;
    padding: 10px 19px 24px;
    margin: 18px 0 20px;
  }
}

.content-list {
  width: 470px;

  &:nth-child(2),
  &:nth-child(5),
  &:nth-child(9) {
    .text {
      height: 68px;

      @include mobile {
        height: auto;
      }
    }
  }

  &:nth-child(7),
  &:nth-child(8) {
    .list-wrapper {

      @include mobile {
        padding-bottom: 0;
      }
    }
  }

}

.list-wrapper {
  display: flex;
  padding: 26px 0;
  border-bottom: 1px solid #000000;

  @include mobile {
    display: flex;
    height: auto;
    padding: 16px 0;
  }
}

.logo {
  display: inline-block;
  width: 24px; height: 24px;
  margin: 5px 20px 0 0;

  @include mobile {
    width: 19px; height: 36px;
    margin: 3px 9px 0 0;
  }
}

.text {
  color: #000000;
  font-size: 18px; font-weight: 400;
  line-height: 34px;
  vertical-align: super;

  &:hover {
    font-weight: 500;
  }

  @include mobile {
    font-size: 14px;
    line-height: 24px;
  }
}

</style>
